import { Stack, Image } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk';
import { MessageBubble, MessageText } from '..';

interface CardMessageProps {
  message: Msg | undefined;
}
const CardMessage = (props: CardMessageProps) => {
  const { message } = props;
  const value = useMemo(
    () => ({
      text: message?.payload?.content,
      image: message?.payload?.background_url,
    }),
    [message?.payload]
  );
  if (value?.image) {
    return <Container avatar={value?.image} msg={value?.text} />;
  }
  return <MessageBubble>{value?.text}</MessageBubble>;
};
const Container = (props: { msg: string; avatar: string }) => {
  const { msg, avatar } = props;
  return (
    <Stack w="335px" overflow="hidden" bg="white" borderRadius="lg">
      <Image borderRadius="lg" src={avatar} />
      <MessageText fontSize="sm" px="3" pb="2" wordWrap="break-word" wordBreak="normal">
        {msg}
      </MessageText>
    </Stack>
  );
};
const MemoCardMessage = memo(CardMessage);
export { MemoCardMessage as CardMessage };
